import React from 'react';
import { useI18n } from '../i18n/I18nProvider.jsx';

export default function Pricing() {
  const { t } = useI18n();
  const features = t('pricing.features');
  return (
    <section className="price-section">
      <div className="price-inner">
        <div className="price-left">
          <div className="p-title-row">
            <div className="accent-line"></div>
            <h2 dangerouslySetInnerHTML={{ __html: t('pricing.title') }} />
          </div>
          <p className="p-desc" dangerouslySetInnerHTML={{ __html: t('pricing.desc') }} />
        </div>
        <div className="price-card">
          <div className="plan-name">{t('pricing.planName')}</div>
          <div className="price-row">
            <h3>{t('pricing.price')}</h3>
            <span>/ {t('pricing.period')}</span>
          </div>
          <div className="free-badge">{t('pricing.badge')}</div>
          <ul className="feat-list">
            {Array.isArray(features) && features.map((f, i) => (
              <li key={i}>
                <span className="feat-chk">
                  <svg viewBox="0 0 15 12" fill="none"><path d="M13.93 1.55L5.04 10.45L1 6.4" stroke="#3B71FE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </span>
                <p>{f}</p>
              </li>
            ))}
          </ul>
          <p className="price-note">{t('pricing.note')}</p>
          <a href="https://flautreach.com/auth"><button className="btn-buy">{t('pricing.cta')}</button></a>
        </div>
      </div>
    </section>
  );
}